import React from 'react';
import { Star, Quote } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Lucía y Manuel',
    text: 'Literalmente salimos sin ganas… pero cumplimos el plan igual 💪🏼. Eso antes no pasaba nunca. Cada día se sienten los cambios. ¡Felices! ❤️',
    img: 'https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Carla G',
    text: 'Nunca fui constante con nada. Hoy ya voy varias semanas sin fallar. Eso para mí es un logro enorme.',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150&q=80'
  }, {
    name: 'Sabrina O',
    text: '¡Lo dimos todo! 😅 Primera vez que termino algo así… 5K y un poquito más ✔️',
    img: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="bg-white py-20 md:py-32" data-id="element-231">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
        <FadeIn data-id="element-233">
          <div className="text-center mb-16" data-id="element-234">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-dark mb-6" data-id="element-235">
              Ellos ya dejaron de{' '}
              <span className="text-primary" data-id="element-236">abandonar</span>
            </h2>
            <div className="flex items-center justify-center gap-1 text-primary mb-4" data-id="element-237">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-238" />)}
            </div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-239">
              Resultados reales de personas reales.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-240">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-241">
              <div className="bg-light p-8 rounded-2xl shadow-sm border border-gray-100 relative h-full flex flex-col" data-id="element-242">
                <Quote className="absolute top-6 right-6 w-10 h-10 text-primary/10" data-id="element-243" />

                <div className="flex items-center gap-1 text-primary mb-6" data-id="element-244">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-245" />)}
                </div>

                <p className="text-gray-700 text-lg italic mb-8 flex-grow" data-id="element-246">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-4 mt-auto" data-id="element-247">
                  <img src={testimonial.img} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-248" />
                  <div data-id="element-249">
                    <p className="font-bold text-dark" data-id="element-250">{testimonial.name}</p>
                    <p className="text-sm text-success font-medium flex items-center gap-1" data-id="element-251">
                      <CheckCircle2 className="w-3 h-3" data-id="element-252" /> Alumno Verificado
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}
// Need to import CheckCircle2 for the verified badge
import { CheckCircle2 } from 'lucide-react';